import { useState } from "react";
import { Crown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useShopper } from "@/components/customer/ShopperProvider";
import { http, errMsg } from "@/lib/api";

export default function MemberDialog({ open, onOpenChange }) {
  const { signIn } = useShopper();
  const [mode, setMode] = useState("login");
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const body = mode === "login" ? { email: f.email, password: f.password } : f;
      const { data } = await http.post(`/auth/${mode}`, body);
      signIn(data);
      toast.success(`Halo ${data.member.name}, harga member sudah aktif`);
      onOpenChange(false);
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="member-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-heading text-2xl"><Crown className="h-6 w-6 text-[#FFB700]" />{mode === "login" ? "Masuk Member" : "Daftar Member"}</DialogTitle>
        </DialogHeader>
        <p className="-mt-2 text-sm text-slate-500">Member mendapat harga khusus di hotel yang ikut program member.</p>
        <form onSubmit={submit} className="space-y-4">
          {mode === "register" && <div><Label htmlFor="mname">Nama</Label><Input id="mname" data-testid="member-name-input" required value={f.name} onChange={set("name")} className="mt-1.5" /></div>}
          <div><Label htmlFor="memail">Email</Label><Input id="memail" data-testid="member-email-input" type="email" required value={f.email} onChange={set("email")} className="mt-1.5" /></div>
          <div><Label htmlFor="mpass">Kata sandi</Label><Input id="mpass" data-testid="member-password-input" type="password" required minLength={6} value={f.password} onChange={set("password")} className="mt-1.5" /></div>
          <button type="submit" disabled={busy} data-testid="member-submit-button" className="flex w-full items-center justify-center gap-2 rounded-xl bg-[#5392F9] py-3 font-heading font-bold text-white transition-colors hover:bg-[#3B7BE6] disabled:opacity-60">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}{mode === "login" ? "Masuk" : "Daftar & Masuk"}
          </button>
        </form>
        <button data-testid="member-toggle-mode" onClick={() => setMode(mode === "login" ? "register" : "login")} className="text-sm font-medium text-[#5392F9] hover:underline">
          {mode === "login" ? "Belum punya akun? Daftar gratis" : "Sudah punya akun? Masuk"}
        </button>
      </DialogContent>
    </Dialog>
  );
}
